import { createContext } from "../ContextSelector";
// const BodyContext = React.createContext<BodyContextProps>(null);
var BodyContext = createContext();
export default BodyContext;